import {extendTheme} from "@chakra-ui/react";
import {theme as proTheme} from '@chakra-ui/pro-theme'

const reaBlue = {
    "50": "#E5F2FF",
    "100": "#B8DBFF",
    "200": "#8AC4FF",
    "300": "#5CADFF",
    "400": "#2E96FF",
    "500": "#007FFF",
    "600": "#0066CC",
    "700": "#004C99",
    "800": "#003366",
    "900": "#001933"
};

let cleanedProTheme = proTheme;

delete cleanedProTheme.components.Link;
delete cleanedProTheme.components.Button;
delete cleanedProTheme.components.Badge;

export const theme = extendTheme(cleanedProTheme, {
    fonts: {
        body: "Open Sans, sans-serif",
        heading: "Open Sans, sans-serif"
    },
    colors: {
        reaBlue,
        brand: reaBlue,
        reaGray: {
            "50": "#F3F3F1",
            "100": "#F1F1EE",
            "200": "#CACABF",
            "300": "#B5B5A6",
            "400": "#A1A18C",
            "500": "#8C8C73",
            "600": "#70705C",
            "700": "#545445",
            "800": "#38382E",
            "900": "#1C1C17"
        }
    },
    components: {
        Alert: {
            baseStyle: (props) => {
                const {status} = props;

                const infoBase = status === "info" && {
                    container: {
                        background: "reaBlue.800",
                        color: "white"
                    },
                    icon: {
                        color: "white"
                    }
                };
                return {
                    ...infoBase,
                };
            }
        },
        Button: {
            variants: {
                reaSecondary: {
                    bg: "reaGray.100",
                    color: "reaBlue.800",
                    fontWeight: 600,
                    _hover: {bg: "reaGray.50"},
                    _disabled: {
                        _hover: {bg: "reaGray.100"}
                    }
                },
                reaPrimary: {
                    bg: "reaBlue.800",
                    color: "white",
                    fontWeight: 600,
                    _hover: {bg: "reaBlue.700"},
                    _disabled: {
                        _hover: {bg: "reaBlue.700"}
                    }
                }
            }
        }
    }
})